import type { Message } from "../../types/message";
import { formatDateTime } from "../../utils";

export function MessageBubble({
  message,
  children,
}: {
  message: Message;
  children: React.ReactNode;
}) {
  const isTemplateMessage =
    typeof message.templateId === "string" &&
    message.templateId.trim().length > 0;

  return (
    <div className="rounded-xl p-1">
      {children}

      <div className="flex items-center justify-end gap-2 py-1">
        {isTemplateMessage ? (
          <span
            className={`text-[11px] font-medium ${
              message.role === "user" ? "text-slate-500" : "text-blue-100"
            }`}
          >
            (template)
          </span>
        ) : null}
        <span
          className={`text-xs ${
            message.role === "user" ? "text-slate-500" : "text-blue-100"
          }`}
        >
          {formatDateTime(message.createdAt)}
        </span>
      </div>
    </div>
  );
}
